// extracted by mini-css-extract-plugin
module.exports = {"indicator":"style_indicator__xIqJT","indicator__name":"style_indicator__name__H522x","indicator__desc":"style_indicator__desc__f1Z2x"};